module.exports = __webpack_public_path__ + "img/nav-theme-light.262af236.svg";